import React, { useState } from "react";
import videoBg2 from "../utils/images/videoBg2.webp";

const VideoSection = () => {
  const [isVideoOpen, setVideoOpen] = useState(false);

  const handlePlayClick = () => setVideoOpen(true);
  const handleCloseClick = () => setVideoOpen(false);

  return (
    <section
      className="relative bg-cover bg-center"
      style={{
        backgroundImage: `url(${videoBg2})`,
        backgroundAttachment: "fixed",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        height: "80vh",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      {/* Video Overlay Section */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white">
        <h2 className="text-4xl font-bold">Watch Promo Video</h2>
        <button
          className="mt-8 flex items-center justify-center w-16 h-16 rounded-full bg-orange-500 hover:bg-orange-600 transition duration-300"
          onClick={handlePlayClick}
        >
          <i className="fas fa-play text-2xl"></i>
        </button>
      </div>

      {/* Video Content Section */}
      {isVideoOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-90 z-50">
          <div className="relative w-full max-w-4xl p-4">
            <button
              className="absolute top-4 right-4 text-white text-2xl hover:text-orange-500 transition duration-300"
              onClick={handleCloseClick}
            >
              <i className="fas fa-times"></i>
            </button>
            <iframe
              className="w-full aspect-video"
              src="https://www.youtube.com/embed/QANY--VN2YE"
              title="Promo Video"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoSection;
